import React, { Component } from 'react'
import * as MabnaButton from './Button/Button'
import { Price } from '../../helpers/utility'
import { toPersianDigit } from '../../helpers/nums'

const styles = {
  wrapper: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', padding: '10px 0' },
  input: { marginLeft: 15, paddingRight: 10 },
}

export default class DiscountInput extends Component {
  state = { value: '' }

  updateValue = event => {
    this.setState({
      value: event.target.value,
    })
  }

  render() {
    const {
      applyDiscount,
      contactingServer,
      priceAfterDiscount,
      // hidePriceAfterDiscount,
      discountPercentage = '',
    } = this.props
    return (
      <section>
        <form onSubmit={applyDiscount} style={styles.wrapper}>
          <input
            ref={input => {
              this.discountInput = input
            }}
            name="promo_code"
            type="text"
            value={this.state.value}
            onChange={this.updateValue}
            placeholder="کد تخفیف"
            style={styles.input}
          />

          <span>
            <MabnaButton.Primary
              outline
              disabled={contactingServer || !this.state.value}
              type="submit"
            >
              بررسی کد
            </MabnaButton.Primary>

            <span>
              {discountPercentage && `${toPersianDigit(discountPercentage)} درصد`}
            </span>
          </span>
        </form>

        {priceAfterDiscount !== null &&
          priceAfterDiscount && (
            <section>
              <hr />
              <span>قیمت با تخفیف: </span>
              <Price>
                {priceAfterDiscount}
              </Price>
            </section>
          )}
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DiscountInput.js